const getSupValue = (str) => {
  let final = str.split(' ');
  final = final.filter(item => item.includes('&sup'));
  return String(final[0].replace(/&sup(.*);/g, '$1'));
};

const removeSup = (str) => {
  const splitedArray = str.split(' ');
  const filterdArray = splitedArray.filter(item => !item.includes('&sup'));
  const final = filterdArray.join(' ');
  return String(final);
};

export { getSupValue, removeSup };



// WEBPACK FOOTER //
// ./src/helpers/superscript.js